import * as angular from "angular";
import {IController, IOnChangesObject} from "angular";

export class BringozCustomSelectComponent implements IController {

  formName?: string;
  selectedValue: any;
  options: any[];
  optionsWrapper: any;
  isRequired: boolean;
  isDisabled: boolean;
  excludeOptions: string[];
  selectedOptions: string[];
  ngPlaceholder: string;
  optionsPrefix: string;
  selectParams: any;
  isHideResetButton: boolean;
  isHideLabel: boolean;
  requiredError: string;
  onChange: Function;

  public selectedText: string;

  constructor(private $mdPanel, private $filter) {
  }

  $onInit() {
    this._setFormName();
    this._setSelectedText();
  };

  $onChanges(changes: IOnChangesObject) {
    if (changes.selectedValue && !changes.selectedValue.isFirstChange()) {
      this._setSelectedText();
    }

    if (changes.formName && !changes.formName.isFirstChange()) {
      this._setFormName();
    }
  }


  onShowPanel($event) {

    if (!!this.isDisabled) {
      return;
    }

    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.bringoz-select-input')
      .withAnimation(this.$mdPanel.animation.FADE);

    const selectedIdRef = this.selectedValue;
    const optionsRef = this.options;
    const optionsWrapperRef = this.optionsWrapper;
    const optionsPrefixRef = this.optionsPrefix;
    const excludeIdsRef = this.excludeOptions;
    const ngPlaceholderRef = this.ngPlaceholder;
    const selectParamsRef = this.selectParams;
    const isHideResetButtonRef = this.isHideResetButton;
    const selectedIdsRef = this.selectedOptions;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<bringoz-select-filter-panel ' +
        'type="ctrl.typeRef" ' +
        'selected-id="ctrl.selectedIdRef" ' +
        'options-prefix="{{ctrl.optionsPrefixRef}}" ' +
        'options="ctrl.optionsRef" ' +
        'options-wrapper="ctrl.optionsWrapperRef" ' +
        'ng-placeholder="ctrl.ngPlaceholderRef" ' +
        'select-params="ctrl.selectParamsRef" ' +
        'panel-ref="ctrl.mdPanelRef" ' +
        'exclude-ids="ctrl.excludeIdsRef"' +
        'selected-ids="ctrl.selectedIdsRef"' +
        'is-hide-reset-button="ctrl.isHideResetButtonRef">' +
        '</bringoz-select-filter-panel>',
      controller: function () {
        this.typeRef = 'custom'
        this.selectedIdRef = selectedIdRef;
        this.optionsRef = optionsRef;
        this.optionsWrapperRef = optionsWrapperRef;
        this.optionsPrefixRef = optionsPrefixRef;
        this.excludeIdsRef = excludeIdsRef;
        this.ngPlaceholderRef = ngPlaceholderRef;
        this.selectParamsRef = selectParamsRef;
        this.isHideResetButtonRef = isHideResetButtonRef;
        this.selectedIdsRef = selectedIdsRef;
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, selectedId) => {
        if (selectedId === 'clickOutsideToClose' || selectedId === 'escapeToClose') {
          selectedId = selectedIdRef;
        }


        if (!selectedId) {
          this.onChange({value: undefined});
        } else {
          this.onChange({value: selectedId});
        }
        panel.destroy();

      }
    };

    this.$mdPanel.open(config);
  }

  onResetFilter() {
    this.onChange({value: undefined});
  }

  private _setSelectedText() {
    if (this.selectedValue) {
      if (!this.optionsWrapper) {
        this.selectedText = this.optionsPrefix ? this.$filter('translate')(this.optionsPrefix + '.' + this.selectedValue) : this.$filter('translate')(this.selectedValue);
      } else {
        const selectedValueWrapperText = this.optionsWrapper.list.find(item => item.id === this.selectedValue)[this.optionsWrapper.propertyRef];
        this.selectedText = this.optionsPrefix ? this.$filter('translate')(this.optionsPrefix + '.' + selectedValueWrapperText) : this.$filter('translate')(selectedValueWrapperText);
      }
    } else {
      this.selectedText = undefined;
    }
  }

  private _setFormName() {
    if (!this.formName) {
      this.formName = "enumSelect"
    }
  }

}

angular
  .module('bringoz.admin.commons')
  .component('bringozCustomSelect', {
    require: {
      form: '^form'
    },
    bindings: {
      formName: '<?',
      selectedValue: '<?',
      options: '<?',
      optionsWrapper: '<?',
      optionsPrefix: '@?',
      isRequired: '<?',
      isDisabled: '<?',
      excludeOptions: '<?',
      selectParams: '<?',
      isHideResetButton: '<?',
      selectedOptions: '<?',
      isHideLabel: '<?',
      requiredError: '@?',
      ngPlaceholder: '@?',
      onChange: '&?'
    },
    template: require('./bringoz-custom-select.html').default,
    controller: BringozCustomSelectComponent
  });

